function resolveLivewireRoot(root) {
    if (!root) {
        return document.body;
    }

    if (typeof root === 'string') {
        return document.querySelector(root) || document.body;
    }

    return root;
}

function resolveLivewire() {
    return window.Livewire || window.livewire || null;
}

function normalizeEventParams(params) {
    if (Array.isArray(params)) {
        return params;
    }

    if (params === undefined) {
        return [];
    }

    return [params];
}

export function refreshLivewireTree(root = document.body) {
    const livewire = resolveLivewire();

    if (livewire && typeof livewire.rescan === 'function') {
        livewire.rescan();
        return;
    }

    const target = resolveLivewireRoot(root);

    if (window.Alpine && typeof window.Alpine.initTree === 'function') {
        window.Alpine.initTree(target);
    }
}

export function restartLivewireTree(root = document.body) {
    const livewire = resolveLivewire();

    if (livewire && typeof livewire.restart === 'function') {
        livewire.restart();
        return;
    }

    refreshLivewireTree(root);
}

export function dispatchLivewireEvent(eventName, params = []) {
    const livewire = resolveLivewire();
    const eventParams = normalizeEventParams(params);

    if (!livewire) {
        return false;
    }

    if (typeof livewire.dispatch === 'function') {
        livewire.dispatch(eventName, eventParams);
        return true;
    }

    if (typeof livewire.emit === 'function') {
        livewire.emit(eventName, ...eventParams);
        return true;
    }

    return false;
}

export function onLivewireEvent(eventName, callback) {
    const livewire = resolveLivewire();

    if (livewire && typeof livewire.on === 'function') {
        return livewire.on(eventName, callback);
    }

    const eventTarget = typeof window !== 'undefined' ? window : document;

    if (!eventTarget || typeof eventTarget.addEventListener !== 'function') {
        return () => {};
    }

    const handler = (event) => callback(event.detail);
    eventTarget.addEventListener(eventName, handler);
    eventTarget.addEventListener(`livewire:${eventName}`, handler);

    return () => {
        eventTarget.removeEventListener(eventName, handler);
        eventTarget.removeEventListener(`livewire:${eventName}`, handler);
    };
}

window.refreshLivewireTree = window.refreshLivewireTree || refreshLivewireTree;
window.restartLivewireTree = window.restartLivewireTree || restartLivewireTree;
window.dispatchLivewireEvent = window.dispatchLivewireEvent || dispatchLivewireEvent;
window.onLivewireEvent = window.onLivewireEvent || onLivewireEvent;
